module.exports = __webpack_public_path__ + "public/images/stand-bg-general.2b536b27c7facc2b98080f7564573e26.webp";